import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendMutationUpdateCustomerArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateCustomerName($id: ID!, $name: String) {
    updateCustomer(id: $id, name: $name) {
      id
      name
    }
  }
`;

type Variables = Pick<BackendMutationUpdateCustomerArgs, 'id' | 'name'>;
type Result = Pick<BackendCustomer, 'id' | 'name'>;

export const updateCustomerName = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
